export default "__VITE_ASSET__67Mkn4Ld__"